export const CURRENT_TENANT_KEY = 'current_tenant';
